import { render } from "./UserOrientedCrb.vue?vue&type=template&id=db981604&scoped=true"
import script from "./UserOrientedCrb.vue?vue&type=script&lang=js"
export * from "./UserOrientedCrb.vue?vue&type=script&lang=js"

import "./UserOrientedCrb.vue?vue&type=style&index=0&id=db981604&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db981604"]])

export default __exports__